import DevelopmentManagement from './'
import { PageRoute } from '../../routes/routerInterface'
import { checkProdSite } from '../../helpers/checkProdSite'

const developmentManagementRouters: PageRoute[] = [
  {
    path: '/development-management',
    element: DevelopmentManagement,
    isProtected: true,
    permission: checkProdSite(true, 'Developer'),
  },
]

export default developmentManagementRouters
